import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

export function Spinner({ className, size = 16, ...props }) {
  return (
    <Loader2
      className={cn('animate-spin', className)}
      size={size}
      {...props}
    />
  );
}
